import _extends from "@babel/runtime/helpers/esm/extends";
import { contextConnect, useContextSystem } from '@wp-g2/context';
import React from 'react';
import { Button } from '../Button';
import { useHistory } from './Router';

function NavigatorBack(props, forwardedRef) {
  var _useContextSystem = useContextSystem(props, 'NavigatorBack'),
      otherProps = _extends({}, _useContextSystem);

  var history = useHistory();
  return /*#__PURE__*/React.createElement(Button, Object.assign({}, otherProps, {
    onClick: history.goBack,
    ref: forwardedRef
  }));
}

export default contextConnect(NavigatorBack, 'NavigatorBack');